import validator from 'validator';

const validators = {
  firstname: function (value) {
    if (this.$refs.formElement.firstname) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  contact_name: function (value) {
    if (this.$refs.formElement.contact_name) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  client_fullname: function (value) {
    if (this.$refs.formElement.client_fullname) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  email: function (value) {
    if (this.$refs.formElement.email && !this.$refs.formElement.email.hidden) {
      return validator.isEmpty(value) ? 'This field is required.' : validator.isEmail(value) ? true : 'Please enter a valid work email address.';
    }
  },
  work_email: function (value) {
    if (this.$refs.formElement.work_email && !this.$refs.formElement.work_email.hidden) {
      return validator.isEmpty(value) ? 'This field is required.' : validator.isEmail(value) ? true : 'Please enter a valid work email address.';
    }
  },
  phone: function (value) {
    if (!this.$refs.formElement.phone) {
      return undefined;
    }
    if (validator.isEmpty(value)) {
      return 'This field is required.';
    }
    const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    if (!phoneRegex.test(value)) {
      return 'Enter a valid phone number.';
    }
    return true;
  },
  partner_type: function (value) {
    if (this.$refs.formElement.partner_type) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  number_of_employees: function (value) {
    if (this.$refs.formElement.number_of_employees) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  numemployees: function (value) {
    if (this.$refs.formElement.numemployees) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  number_of_clients: function (value) {
    if (this.$refs.formElement.number_of_clients) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  gdpr_consent: function (value) {
    if (this.$refs.formElement.gdpr_consent) {
      return value === true ? true : 'This field is required.';
    }
  },
  gdpr_consent_partners_referral: function (value) {
    if (this.$refs.formElement.gdpr_consent_partners_referral) {
      return value === true ? true : 'This field is required.';
    }
  },
  extension_feedback: function (value) {
    if (this.$refs.formElement.extension_feedback) {
      return validator.isEmpty(value) ? 'This field is required.' : true;
    }
  },
  active_users_count: function (value) {
    if (this.$refs.formElement.active_users_count) {
      return validator.isEmpty(value) || !validator.isNumeric(value) ? 'This field is required and must be a number.' : true;
    }
  },
};

export default validators;